import React from 'react';
import Messages from "./TicketMessages"
import  TicketProcessCard from "./TicketProcessCard"
import TicketGallery from "./TicketGallery"
import TicketProcessInstallCard from "./TicketProcessInstallCard"
import TicketApproval from "./TicketApproval"

import { useState } from "react";

function Ticket(){

    const [processState, setProcessState] = useState("");

    let Process = () => {
        switch (processState) {
          case "":
            return (
              <>
              <TicketProcessCard />
              </>
            );
            break;
    
          case "install":
            return (
              <>
            <TicketProcessInstallCard />
              </>
            );
            break;
    
          case "closed":
            return (
              <>
              
              </>
            );
            break;

            case "approval":
            return (
              <>
              Approval Card
              </>
            );
            break;
    
      
              
        }
      };

    return (
       
        <>
          
<div class="col-md-5">
            <div class="card p-3 mb-4">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-row align-items-center">
                        <div class="iconCard">   <span class="material-symbols-rounded">confirmation_number</span> </div>
                        <div class="ms-2 c-details">
                            <h6 class="mb-0">Ticket</h6> <span>Active Ticket</span>
                        </div>
                    </div>
                   {/* <div class="badge"> <span>Z-Range</span> </div>*/} 
                </div>
                <div class="mt-3">
                    <p class="heading"><strong>Client Name</strong></p>
                    <div class="mt-3">

                    <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">confirmation_number</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Logged: </strong>14 June 2013</span>
  
  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>confirmation_number</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Number: </strong>0924588774</span>


  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>error</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Fault Cables</span>
  </div>
                        

  <hr />

  <p><strong>Description </strong></p>

  <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">description</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>Tafadskfa adkjfaoidj adjf t jakdjf adksjf aoad fakdmd fakdfna djfd jblkej akdjf ejapakdfj jadkajd kfj aekjaldkjf adksjf akdsjf kdjoakjlkdjf abiehajf kadj
  
  </span>
  
 
  </div>

  <hr />

<p><strong>Inverter & Battery </strong></p>

<div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">charger</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Inverter: </strong>adfadsf</span>
  
  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Battery: </strong>z-Range</span>

  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Battery Size: </strong>2</span>

  </div>
  
 





                        <hr />

                        <p><strong>Installer Details </strong></p>
                        <div className='smallInfo' style={{display: "flex"}}>
                            
                            <span class="material-symbols-rounded writing">person</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Name: </strong>Trust Installer</span>
  
  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>phone</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Install Phone: </strong>098 8245 234</span>


  <span class="material-symbols-rounded writing" style={{paddingLeft:"20px"}}>email</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Email: </strong>trust@i-g3n.com</span>


  </div>
                     {/*    <div class="mt-3"> <span class="text1">32 Applied <span class="text2">of 50 capacity</span></span> </div>*/}
                    </div>




                    <hr />

                    <div className='smallInfo' style={{display: "flex", justifyContent:"end"}}>
 
  <span style={{width:"31%"}}>

<span className="BIcon3" data-toggle="modal" data-target="#GallaryModal" style={{height:"100%" , margin: "0px",  paddingTop:"6px", fontSize:"12px", paddingLeft:"15px"}}><span class="material-symbols-rounded size"  style={{paddingTop:"4px"}} >photo_library</span> <span style={{paddingTop:"8px", paddingLeft:"5px"}}>Gallery</span></span>

</span></div>


                </div>
            </div>






{/*Process */}



{Process()}

{/*End Process 


*/}






            </div>
            <div class="col-md-5">
                {processState === "approval"? <TicketApproval />:""}

            <Messages />

            
         

            </div>

       



            {/* Modal className='modal-dialog'   style={{width:"70%", margin:"auto",}}*/}
<div className="modal fade" id="GallaryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className='modal-dialog' role="document" style={{width:"70%"}} >
    <div className="modal-content">
      <div className="modal-header">
       {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>*/} 
       <div className="d-flex flex-row align-items-center">
                        <div className="iconCard"> 
                        <span className="material-symbols-rounded">photo_library</span>
                         </div>
                        <div className="ms-2 c-details">
                            <h6 className="mb-0">Gallery</h6>{/* <span>Pending Ticket Approval</span> */}
                        </div>
                    </div>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
      <TicketGallery />
      </div>
      {/* 
      <div className="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
      */}
    </div>
  </div>
</div>
            {/* End Modal */}


        </>
    )
}

export default Ticket;






















